import { render, staticRenderFns } from "./PageDisplayer.vue?vue&type=template&id=3e2f13d2&"
import script from "./PageDisplayer.vue?vue&type=script&lang=js&"
export * from "./PageDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports